import "./ProgressStep.scss";

interface ProgressStepProps {
  title?: string;
  isActive?: boolean;
  isComplete?: boolean;
}

function ProgressStep({ title, isActive, isComplete }: ProgressStepProps) {
  const stepsClasses = `step-progress-bar ${isActive ? "active" : ""} ${isComplete ? "complete" : ""}`;

  return (
    <div className="progress-step-container">
      <div className={`${stepsClasses}`} />
      {title && <div className={`${isActive ? "" : "text-secondary"} progress-step-container__title`}>{title}</div>}
    </div>
  );
}

ProgressStep.defaultProps = {
  isComplete: false,
  isActive: false,
  title: "",
};

export default ProgressStep;
